import React from "react";
import * as assets from "../info";

const TechnologyPolicy = ({ darkTheme }) => {
  return (
    <div id="policy" className="modal fade" role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div
          className={
            "modal-content " + (darkTheme ? "bg-dark-2 text-light" : "")
          }
        >
          <div className="modal-header">
            <h5 className={"modal-title " + (darkTheme ? "text-white" : "")}>
              Technology Policy
            </h5>
            <button
              type="button"
              className={"btn-close " + (darkTheme ? "btn-close-white" : "")}
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body p-4" style={{ whiteSpace: "pre-wrap" }}>
            {assets.technologyPolicy.statement}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnologyPolicy;
